module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_a-function.js
// module id = 1090
// module chunks = 1